export class UserFilter {
  userid: string;
  accountId: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  role: string;
  createdtime: string;
  disabled: string;
  send: string;
  locked: string;

  constructor() {
  }

  reset() {
    this.userid = '';
    this.accountId = '';
    this.firstname = '';
    this.lastname = '';
    this.email = '';
    this.phone = '';
    this.role = '';
    this.createdtime = '';
    this.disabled = '';
    this.send = '';
    this.locked = '';
  }
}
